// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__qRoex","background":"styles_background__9Uf4g"};